import React from 'react';
import CensusSection from '../Common/CensusSection';
import Panorama from './Panorama';
import BasicSector from './BasicSector';
import PopulationProjection from './PopulationProjection';

const Overview = () => (
    <CensusSection
        menuPath="overview"
        pages={[
            { path: 'panorama', title: 'Panorama Básico', element: <Panorama /> },
            { path: 'basic-sector', title: 'Setor Básico', element: <BasicSector /> },
            { path: 'population-projection', title: 'Projeção Populacional', element: <PopulationProjection /> }
        ]}
    />
);

export default Overview;
